import type { JSX } from "react";

import { PermissionsDiagnosticsPage } from "../../../diagnostics/PermissionsDiagnosticsPage.js";

/** Read-only GTCC entry point for the existing redacted permission diagnostics. */
export function GtccPermissionsView(): JSX.Element {
  return (
    <section data-testid="gtcc-permissions-view">
      <PermissionsDiagnosticsPage />
    </section>
  );
}
